import { IconTagTypes } from '../../model/tag-types.model';

export function isIconTagType(value: string): value is IconTagTypes {
  const values = Object.values(IconTagTypes) as string[];
  return values.includes(value);
}
